import { useContext } from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';

import { ErrorBoundary, ScrollToTop } from 'components';
import { BRANDS } from 'config/environments/shared';
import {
  Catalogs,
  ContentBuiltIn,
  ContentBuilder,
  CycleHighlights,
  CurrentCycle,
  FullImagesToShare,
  HomeContent,
  ImagesToShare,
  ImportantWarnings,
  IncentiveCampaign,
  IncentiveCampaignResults,
  NextCycle,
  ResellerMagazine,
  ResellerPlace,
  OptOut,
  Order,
  Orders,
  Profile,
  TipsAndTrainings,
} from 'pages';
import { GlobalContext } from 'store';

export const APP_PATHS = {
  AVISOS_IMPORTANTES: '/avisos-importantes',
  CATALOGS: '/catalogos-dos-ciclos',
  CATALOG_OPTOUT: '/configurar-catalogo',
  CURRENT_CYCLE_CATALOG: '/catalogos-dos-ciclos/ciclo-atual',
  DEPARTAMENTS: '/departamentos',
  DESTAQUES_DO_CICLO: '/destaques-do-ciclo',
  DETAIL: `/pedido`,
  DICAS_E_TREINAMENTOS: '/dicas-e-treinamentos',
  GUIA_DIGITAL: '/guia-digital',
  IMAGES_TO_SHARE: '/imagens-de-divulgacao',
  LIST: `/pedidos`,
  LOYALTY_INCENTIVE_CAMPAIGN: '/campanha-de-incentivos',
  LOYALTY_INCENTIVE_CAMPAIGN_RESULTS: '/campanha-de-incentivos/:content/resultado',
  PERFIL: `/perfil/*`,
  MATERIAIS: '/materiais',
  NEXT_CYCLE_CATALOG: '/catalogos-dos-ciclos/proximo-ciclo',
  RESELLER_MAGAZINE_BOT: '/revista-do-revendedor',
  RESELLER_MAGAZINE_EUD: '/guia-mais',
  RESELLER_PLACE_BOT: '/espaco-do-revendedor',
  RESELLER_PLACE_EUD: '/espaco-do-representante',
  ROOT: '/',
};

export const AppRoutes = () => {
  const { brand } = useContext(GlobalContext);
  const isEud = BRANDS.EUD == brand.short;

  return (
    <ErrorBoundary>
      <Routes>
        {/* Departamentos - Stargate */}
        <Route path={APP_PATHS.DEPARTAMENTS} element={<HomeContent />} />

        {/* Pedidos */}
        <Route path={APP_PATHS.ROOT} element={<Navigate to={APP_PATHS.LIST} replace />} />
        <Route path={APP_PATHS.LIST} element={<Orders />} />
        <Route
          path={`${APP_PATHS.DETAIL}/:id`}
          element={
            <ScrollToTop>
              <Order />
            </ScrollToTop>
          }
        />

        {/* Catálogos do Ciclo */}
        {!isEud && <Route path={APP_PATHS.CURRENT_CYCLE_CATALOG} element={<CurrentCycle />} />}
        {!isEud && <Route path={APP_PATHS.NEXT_CYCLE_CATALOG} element={<NextCycle />} />}
        <Route path={!isEud ? APP_PATHS.CATALOGS : APP_PATHS.GUIA_DIGITAL} element={<Catalogs />} />

        {/* Imagens de Divulgação */}
        <Route path={APP_PATHS.IMAGES_TO_SHARE} element={<ImagesToShare />} />
        <Route path={`${APP_PATHS.IMAGES_TO_SHARE}/:content`} element={<FullImagesToShare />} />

        {/* OptOut Catálogo Físico */}
        <Route path={APP_PATHS.CATALOG_OPTOUT} element={<OptOut />} />

        {/* Revista dos Revendedores */}
        <Route
          path={isEud ? APP_PATHS.RESELLER_MAGAZINE_EUD : APP_PATHS.RESELLER_MAGAZINE_BOT}
          element={<ResellerMagazine />}
        />

        {/* Perfil */}
        <Route path={APP_PATHS.PERFIL} element={<Profile />} />

        {/* Destaques do Ciclo */}
        <Route path={APP_PATHS.DESTAQUES_DO_CICLO} element={<CycleHighlights />} />

        {/* Dicas e Treinamentos */}
        <Route path={APP_PATHS.DICAS_E_TREINAMENTOS} element={<TipsAndTrainings />} />

        {/* Avisos Importantes */}
        <Route path={APP_PATHS.AVISOS_IMPORTANTES} element={<ImportantWarnings />} />

        {/* Encontre seu ER */}
        <Route
          path={isEud ? APP_PATHS.RESELLER_PLACE_EUD : APP_PATHS.RESELLER_PLACE_BOT}
          element={<ResellerPlace />}
        />

        {/* BuiltInContentRoutes */}
        <Route
          path={`${APP_PATHS.DESTAQUES_DO_CICLO}/:content`}
          element={<ContentBuiltIn document='destaques_do_ciclo' />}
        />
        <Route
          path={`${APP_PATHS.DICAS_E_TREINAMENTOS}/:content`}
          element={<ContentBuiltIn document='dicas_e_treinamentos' />}
        />
        <Route
          path={`${APP_PATHS.AVISOS_IMPORTANTES}/:content`}
          element={<ContentBuiltIn document='avisos_importantes' />}
        />

        {/* Materiais */}
        <Route path={`${APP_PATHS.MATERIAIS}/:title`} element={<ContentBuilder />} />

        {/* Fidelidade */}
        <Route
          path={`${APP_PATHS.LOYALTY_INCENTIVE_CAMPAIGN}/:content`}
          element={<IncentiveCampaign />}
        />
        <Route
          path={APP_PATHS.LOYALTY_INCENTIVE_CAMPAIGN_RESULTS}
          element={<IncentiveCampaignResults />}
        />
      </Routes>
    </ErrorBoundary>
  );
};
